/** Reemplazo de `UnsupportedChainIdError` de web3-react para UI que comprueba `instanceof`. */
export class WrongNetworkError extends Error {
  constructor(message?: string) {
    super(message ?? 'Wrong network')
    this.name = 'WrongNetworkError'
    Object.setPrototypeOf(this, WrongNetworkError.prototype)
  }
}
